/**
 * partnerFallback — BLU-3xx Phase 47.01.2-B-fix2 NEW-FH2
 *
 * Shared helper for rendering the placeholder label of an unresolved
 * partner organization across cross-org inventory surfaces. Pre-fix sweep,
 * three callers (ClientFilterDropdown, ReceiveHistoryTable,
 * ReverseReceiptDialog) drifted apart: the dropdown rendered "Partner #1"
 * (a 1-based index) while the receive-history surfaces rendered
 * "Partner #abc123" (a hex slice). Same unresolved org appearing in two
 * panels would carry two different labels — confusing.
 *
 * Decision: 6-char hex slice wins. It uniquely identifies the org at a
 * glance, matches what we already log to Sentry breadcrumbs, and gives
 * support a quick path from a screenshot back to a row in the orgs table.
 *
 * Use:
 *   const { t } = useTranslation('inventory');
 *   const label = orgIdToName.get(orgId)
 *     ?? t('crossOrg.partnerFallbackHex', { hex: hexSlice(orgId) });
 *
 * Keep this a tiny pure helper — DON'T import t() into it. The call site
 * needs the i18n context anyway and inlining the t() lookup keeps i18n
 * tooling (ts-i18next, i18next-parser) able to extract the key.
 */
export function hexSlice(orgId: string): string {
  return orgId.slice(0, 6);
}
